/**
 * @generated SignedSource<<5f7d0c036791eadb4f518c53e03a3f7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AllSoftwareInstrumentsQuery$variables = Record<PropertyKey, never>;
export type AllSoftwareInstrumentsQuery$data = {
  readonly myInstruments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly uniqueCode: string;
      };
    }> | null | undefined;
  } | null | undefined;
};
export type AllSoftwareInstrumentsQuery = {
  response: AllSoftwareInstrumentsQuery$data;
  variables: AllSoftwareInstrumentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MyInstrumentsConnection",
    "kind": "LinkedField",
    "name": "myInstruments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MyInstrumentsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Instrument",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uniqueCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllSoftwareInstrumentsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AllSoftwareInstrumentsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "bfa9bd6ff2c6b22506fa834fc1290716",
    "id": null,
    "metadata": {},
    "name": "AllSoftwareInstrumentsQuery",
    "operationKind": "query",
    "text": "query AllSoftwareInstrumentsQuery {\n  myInstruments {\n    edges {\n      node {\n        id\n        uniqueCode\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "593695a7d59add5c3c18affce5beec85";

export default node;
